module.exports = __webpack_public_path__ + "media/images/logo-2x-9eff7405.png";